import React from 'react';
import clsx from 'clsx';

interface SkeletonDropdownItemProps {
  count?: number;
}

const SkeletonDropdownItem: React.FC<SkeletonDropdownItemProps> = ({ count = 1 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <li
          key={index}
          className={clsx(
            'relative py-2 pl-4 pr-4 animate-fadePulse',
            'bg-gray-100 dark:bg-gray-700'
          )}
        >
          <div className="flex items-center">
            <div className="w-4 h-4 bg-gray-300 dark:bg-gray-600 rounded mr-2"></div>
            <div className="w-3/4 h-3 bg-gray-300 dark:bg-gray-600 rounded"></div>
          </div>
        </li>
      ))}
    </>
  );
};

export default SkeletonDropdownItem;